import { createSelector } from 'reselect';

import searchItems from 'utils/searchItems';

import { getDebouncedSearchValue } from 'store/search/selectors';

import { getUser } from './user.selectors';

export const getLicenses = createSelector(getUser, ({ licenses }) => licenses);

const getLicensesValues = createSelector(getLicenses, licenses => Object.values(licenses));

export const getFilteredLicenses = createSelector(
  getDebouncedSearchValue,
  getLicensesValues,
  searchItems(license => [license.state.abbreviation]),
);
